import { Card, CardContent } from '@frontend/components/ui/card';

interface AutomationRateBarProps {
  automated: number; // helpful + unrated
  notAutomated: number; // unhelpful + no_answer
}

export function AutomationRateBar({
  automated,
  notAutomated,
}: AutomationRateBarProps) {
  const total = automated + notAutomated;

  // Avoid division by zero
  if (total === 0) {
    return null;
  }

  const automatedPercentage = Math.round((automated / total) * 100);
  const notAutomatedPercentage = 100 - automatedPercentage;

  return (
    <Card className="py-0 gap-0 w-full h-[200px]">
      <CardContent className="p-5 w-full h-full flex flex-col">
        <h3 className="text-gray-600 mb-4" style={{ fontSize: '13px' }}>
          Resolution Rate
        </h3>

        {/* Percentages and Labels - stacked at bottom */}
        <div className="flex items-end justify-between gap-6 mb-4 mt-auto">
          <div className="flex flex-col items-start">
            <div
              className="text-gray-800 mb-1"
              style={{ fontSize: '32px', fontWeight: 'normal' }}
            >
              {automatedPercentage}%
            </div>
            <div className="flex items-center gap-1.5">
              <div
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: '#9FF482' }}
              ></div>
              <span className="text-gray-600" style={{ fontSize: '13px' }}>
                {automated.toLocaleString()} / Agent
              </span>
            </div>
          </div>
          <div className="flex flex-col items-end">
            <div
              className="text-gray-800 mb-1"
              style={{ fontSize: '32px', fontWeight: 'normal' }}
            >
              {notAutomatedPercentage}%
            </div>
            <div className="flex items-center gap-1.5">
              <div
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: '#73DFE9' }}
              ></div>
              <span className="text-gray-600" style={{ fontSize: '13px' }}>
                {notAutomated.toLocaleString()} / Team
              </span>
            </div>
          </div>
        </div>

        {/* Horizontal segmented bar - moved to bottom */}
        <div className="w-full h-8 rounded-lg overflow-hidden flex gap-px">
          <div
            className="h-full rounded-l-lg"
            style={{
              width: `${automatedPercentage}%`,
              backgroundColor: '#9FF482',
            }}
          ></div>
          <div
            className="h-full rounded-r-lg"
            style={{
              width: `${notAutomatedPercentage}%`,
              backgroundColor: '#73DFE9',
            }}
          ></div>
        </div>
      </CardContent>
    </Card>
  );
}
